import React from 'react';

import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import TagChip from '@asteria/component-tags/tag';

import * as AppStore from '@asteria/datalayer/stores/app';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps & { section: unknown, object: unknown }> } */
const RowTags = React.memo(function RowTags(props) {
	const { query, object } = props;

	const tags = useSelector((store) =>
		AppStore.selectors.tags(store).filter((tag) => {
			const id = tag?._id ?? tag?.id;

			return (object?.value ?? []).includes(id);
		}),
	);

	return (
		<div className="flex flex-wrap gap-1">
			{tags.map((tag) => {
				const id = tag?._id ?? tag?.id;

				return (
					<TagChip
						key={id}
						type={query?.data?.type}
						tag={tag}
						size="md"
						analyticsKey="transactions.details.tag"
						analytics={{ tag: tag }}
					/>
				);
			})}
		</div>
	);
});

RowTags.propTypes = {
	query: PropTypes.object,
	object: PropTypes.object,
};

export default RowTags;
